export const isPending = actionsArray => actionsArray && actionsArray.find(action => action.status === 'PENDING');
export const isApproved = actionsArray => actionsArray && actionsArray.find(action => action.status === 'APPROVED');
export const getPotentialResponders = actionsArray => isPending(actionsArray) ? isPending(actionsArray).potentialResponders : [];
export const hasAlert = alerts => alerts && !!alerts.length;

export const jobTypes = {
  my: 'myJobs',
  other: 'otherJobs',
}

export const jobActions = {
  reportLevel: 'reportLevel',
  APPROVE_REPORT: 'approveReport',
  REOPEN_REPORT: 'reopenReport',
};

export const warrantyTypes = {
  START: 'start',
  END: 'end',
  TECHNICAL_WARRANTY: 'technicalWarranty',
  EDIT_TECHNICAL_WARRANTY: 'editTechnicalWarrantyDialog',
  AMEND_TECHNICAL_WARRANTY: 'amendTechnicalWarrantyDialog',
  AMEND_COMMERCIAL_DECISION: 'amendCommercialDecisionDialog',
  COMMERCIAL_DECISION: 'commercialDecision',
  START_DATE: 'warrantyStartDate',
  END_DATE: 'warrantyEndDate',
};

export const isLastActionApproved = (actionsArray, action) => {
  const lastActionIndex = actionsArray && actionsArray[action].length - 1;

  return actionsArray && actionsArray[action] && actionsArray[action][lastActionIndex] &&
         actionsArray[action][lastActionIndex].status === 'APPROVED'
}

const steps = translations => [
  { value: 'receivedProductSectionProgress', label: translations.productReceived },
  { value: 'productEvaluationSectionProgress', label: translations.productEvaluation },
  { value: 'stripObservationSectionProgress', label: translations.stripObservation },
  { value: 'technicalInvestigationSectionProgress', label: translations.technicalInvestigation },
  { value: 'conformityTestSectionProgress', label: translations.conformityTest }
];

// Order is important - it is the render order in MultiStepper
export const statuses = translations => [
  { value: 'awaitingEquipment', label: translations.awaitingEquipment },
  { value: 'equipmentReceivedWithDocumentation', label: translations.equipmentReceivedWithDocumentation },
  { value: 'jobReleased', label: translations.jobReleased },
  { value: 'productEvaluation', label: translations.productEvaluation },
  { value: 'strippedAndDecontaminated', label: translations.strippedAndDecontaminated },
  { value: 'builtAndTested', label: translations.builtAndTested },
  { value: 'shipped', label: translations.shipped },
  { value: 'closed', label: translations.closed },
  { value: 'productInvestigation', label: translations.productInvestigation },
  { value: 'technicalAndCommercialDecision', label: translations.technicalAndCommercialDecision },
  { value: 'finalReportReleased', label: translations.finalReportReleased },
];

export const otherStatusBranch = ['productInvestigation', 'technicalAndCommercialDecision', 'finalReportReleased'];

export const getJobProgress = (jobProgress, translations) =>
  steps(translations).reduce((acc, step) =>
      [...acc, { id: step.value, label: step.label, status: jobProgress[step.value] }]
  , []);

export const getJobStatus = (jobStatus, translations) =>
  statuses(translations).reduce((acc, step) =>
    [...acc, { id: step.value, label: step.label, status: jobStatus[step.value] }]
  , []);

// These 3 consts are used for calculating last updated status.
// *Must* be ordered backwards
const workBranch = ['closed', 'shipped', 'builtAndTested', 'strippedAndDecontaminated', 'productEvaluation', 'jobReleased', 'equipmentReceivedWithDocumentation'];
const analysisBranch = ['finalReportReleased', 'technicalAndCommercialDecision', 'productInvestigation'];

// Returns Array of last updated statuses.
// A[0] - lastWorkBranchStatusUpdated
// A[1] - lastAnalysisBranchStatusUpdated or 'notStarted' (related to the last analysis status)
export const getLastUpdatedStatus = status => {
  const lastAnalysisBranchStatusUpdated = analysisBranch.find(st => status[st] === 'FULFILLED');
  const lastWorkBranchStatusUpdated = workBranch.find(st => status[st] === 'FULFILLED') || 'awaitingEquipment';

  return [lastWorkBranchStatusUpdated, lastAnalysisBranchStatusUpdated || 'notStarted'];
};



// WEBPACK FOOTER //
// ./src/constants/job.js